import axios, { AxiosRequestConfig } from "axios";

/**
 * S3操作周りのAPIリクエスト。
 */
export default class S3ApiRequest {
	/**
	 * 署名付きURLを使用しファイルをアップロード。
	 */
	public async uploadFile(file: File, presignedUrl: string): Promise<void> {
		const options: AxiosRequestConfig = {
			url: presignedUrl,
			method: "PUT",
			headers: {
				"Content-Type": file.type,
				Origin: location.origin,
			},
			data: file,
		};
		try {
			const result = await axios(options);
			if (result.status !== 200) {
				throw new Error("S3へのファイルアップロードに失敗しました。");
			}
		} catch (error) {
			// axios型のエラーオブジェクトであれば型推論が効くので、それで対応
			if (axios.isAxiosError(error)) {
				console.error(`S3 API Request error:
status:  ${error.response?.status}
requestUrl: ${error.response?.config.url}`);
				throw error.response?.data;
			}

			// そうでなければとりあえずエラー内容全てをThrow
			throw error;
		}
	}
}
